import { render, staticRenderFns } from "./HrHireAdjustOrgrel.vue?vue&type=template&id=2132c898&scoped=true&"
import script from "./HrHireAdjustOrgrel.vue?vue&type=script&lang=js&"
export * from "./HrHireAdjustOrgrel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132c898",
  null
  
)

export default component.exports